import React from "react"
import {Space} from "antd"
import {ChartType} from "./types/ChartType";
import styles from './Visualisations.module.scss';
import {ReactComponent as BarChartIcon} from "./icons/bar.svg"
import {ReactComponent as StackedBarChartIcon} from "./icons/stacked-bar.svg"
import {ReactComponent as LineChartIcon} from "./icons/line.svg"
import classNames from "classnames";

type ChartSelectProps = Pick<ChartTypeSelectorProps, 'selectedChart' | 'onSelectChart'> & {
    title: string,
    type: ChartType,
    icon: React.ReactElement
}

const ChartSelect = ({title, type, icon, selectedChart, onSelectChart}: ChartSelectProps) => {
    const isSelected = selectedChart === type

    return <div
        className={classNames(styles['chart-selector'], {[styles['selected-chart']]: isSelected})}
        onClick={() => onSelectChart(type)}
        data-testid={`chart-select-${type}`}
    >
        {icon}
        <span className={styles['chart-select-title']}>{title}</span>
    </div>
}

export type ChartTypeSelectorProps = {
    selectedChart: ChartType,
    onSelectChart: (chartType: ChartType) => void
}

export const ChartTypeSelector = ({selectedChart, onSelectChart}: ChartTypeSelectorProps) => {
    return <Space direction="vertical" className={styles['select-chart-type']}>
        <div className={styles.chartSelector}>Visual</div>
        <ChartSelect
            selectedChart={selectedChart}
            onSelectChart={onSelectChart}
            title="Bar"
            type={ChartType.BAR}
            icon={<BarChartIcon/>}
        />
        <ChartSelect
            selectedChart={selectedChart}
            onSelectChart={onSelectChart}
            title="Stacked Bar"
            type={ChartType.STACKED_BAR}
            icon={<StackedBarChartIcon/>}
        />
        <ChartSelect
            selectedChart={selectedChart}
            onSelectChart={onSelectChart}
            title="Line"
            type={ChartType.LINE}
            icon={<LineChartIcon/>}
        />
    </Space>
}